import { injectable } from 'inversify'

/**
 * Wraps navigator.onLine and the online/offline window events (invariant 8:
 * all browser APIs behind a gateway).
 */
@injectable()
export class ConnectivityGateway {
  isOnline(): boolean {
    return navigator.onLine
  }

  // Returns an unsubscribe function.
  onChange(callback: (online: boolean) => void): () => void {
    const onOnline = () => callback(true)
    const onOffline = () => callback(false)
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)
    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }
}
